// Capacitor platform helpers. All functions are safe on web (no-op / browser fallbacks),
// so the same React bundle runs in the browser and inside the iOS WKWebView wrapper.
import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Preferences } from "@capacitor/preferences";

export const isNative = () => {
  try { return Capacitor?.isNativePlatform?.() ?? false; } catch { return false; }
};
export const platform = () => {
  try { return Capacitor?.getPlatform?.() ?? "web"; } catch { return "web"; }
};

export async function initStatusBar() {
  if (!isNative()) return;
  try { await StatusBar.setStyle({ style: Style.Dark }); } catch { /* non-fatal */ }
}

// Prefer CoreLocation on native (contextual permission), navigator.geolocation on web.
export async function getCurrentPosition() {
  if (isNative()) {
    const pos = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 10000 });
    return { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
  }
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("geolocation-unavailable"));
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ latitude: p.coords.latitude, longitude: p.coords.longitude }),
      (e) => reject(e),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 },
    );
  });
}

const DEVICE_KEY = "leadctrl_device_id";
export async function stableDeviceId() {
  try {
    const { value } = await Preferences.get({ key: DEVICE_KEY });
    if (value) return value;
    const id = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : `dev-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    await Preferences.set({ key: DEVICE_KEY, value: id });
    return id;
  } catch {
    return `dev-${Date.now()}`;
  }
}
